/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';
import { PositionPropTypes } from '@instructure/ui-position';
import { controllable, Children as ChildrenPropTypes } from '@instructure/ui-prop-types';
const propTypes = {
  children: ChildrenPropTypes.oneOf(['MenuItem', 'MenuItemGroup', 'MenuItemSeparator', 'Menu']),
  label: PropTypes.string,
  disabled: PropTypes.bool,
  trigger: PropTypes.node,
  placement: PositionPropTypes.placement,
  defaultShow: PropTypes.bool,
  show: controllable(PropTypes.bool, 'onToggle', 'defaultShow'),
  onToggle: PropTypes.func,
  onSelect: PropTypes.func,
  onDismiss: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseOver: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  menuRef: PropTypes.func,
  popoverRef: PropTypes.func,
  mountNode: PositionPropTypes.mountNode,
  constrain: PositionPropTypes.constrain,
  shouldHideOnSelect: PropTypes.bool,
  shouldFocusTriggerOnClose: PropTypes.bool,
  positionContainerDisplay: PropTypes.oneOf(['inline-block', 'block']),
  type: PropTypes.oneOf(['flyout']),
  id: PropTypes.string,
  withArrow: PropTypes.bool,
  offsetX: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offsetY: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxHeight: PropTypes.string,
  renderLabelInfo: PropTypes.node
};
const allowedProps = ['children', 'label', 'disabled', 'trigger', 'placement', 'defaultShow', 'show', 'onToggle', 'onSelect', 'onDismiss', 'onFocus', 'onMouseOver', 'onKeyDown', 'onKeyUp', 'menuRef', 'popoverRef', 'mountNode', 'constrain', 'shouldHideOnSelect', 'shouldFocusTriggerOnClose', 'positionContainerDisplay', 'type', 'id', 'withArrow', 'offsetX', 'offsetY', 'maxHeight', 'renderLabelInfo'];
export { propTypes, allowedProps };